"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _PageBreak = _interopRequireDefault(require("./DOMComponents/PageBreak"));

var _TextNode = _interopRequireDefault(require("./DOMComponents/TextNode"));

var _Table = _interopRequireDefault(require("./DOMComponents/Table"));

var _Image = _interopRequireDefault(require("./DOMComponents/Image"));

var _Raw = _interopRequireDefault(require("./DOMComponents/Raw"));

var _Variable = _interopRequireDefault(require("./DOMComponents/Variable"));

var _HeaderFooter = require("./DOMComponents/HeaderFooter");

var _TableRowContainer = _interopRequireWildcard(require("./DOMComponents/TableRowContainer"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  br: _PageBreak["default"],
  div: _TextNode["default"],
  h1: _TextNode["default"],
  h2: _TextNode["default"],
  h3: _TextNode["default"],
  h4: _TextNode["default"],
  h5: _TextNode["default"],
  h6: _TextNode["default"],
  p: _TextNode["default"],
  span: _TextNode["default"],
  small: _TextNode["default"],
  b: _TextNode["default"],
  em: _TextNode["default"],
  ol: _TextNode["default"],
  ul: _TextNode["default"],
  li: _TextNode["default"],
  a: _TextNode["default"],
  table: _Table["default"],
  thead: _TableRowContainer.TableHeader,
  th: _TextNode["default"],
  tbody: _TableRowContainer.TableBody,
  tr: _TableRowContainer["default"],
  td: _TextNode["default"],
  img: _Image["default"],
  raw: _Raw["default"],
  header: _HeaderFooter.Header,
  footer: _HeaderFooter.Footer,
  currentpage: _Variable["default"],
  totalpages: _Variable["default"]
};
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@harvest-profit/doc-flux-pdfs/dist/Parser.js
// module id = 10
// module chunks = 0